import React, { Component } from 'react'
import { Button, Modal, Checkbox } from 'antd';
import intl from 'react-intl-universal';
import './Message.dialog.scss'
import { store } from 'Store/store.index';

export default class MessageDialog extends Component {
    /**
     *Creates an instance of MessageDialog.
     * @param {Object} props
     * @param {Object} props.msg
     * @param {String} props.msg.id message key id
     * @param {Object} props.msg.title title key
     * @param {Object} props.msg.cancel button key
     * @param {Object} props.msg.ok button key
     * @param {Object} props.msg.checkbox checkbox {title, checked}
     * @param {String} props.msg.checkbox.title button key
     * @param {Boolean} props.msg.checkbox.checked button default value
     * @memberof MessageDialog
     */
    constructor(props) {
        super(props);
        const {msg} = props;
        let checkbox = !!msg.checkbox?msg.checkbox:null;
        this.state = {
          msg,
          checkbox,
          checked:(checkbox && checkbox.checked !== void 0)?checkbox.checked:true,
          timer:null
        }
        this.onOk = this.onOk.bind(this);
        this.onCancel = this.onCancel.bind(this);
        this.onCheckBox = this.onCheckBox.bind(this);
        this.onRunTimer = this.onRunTimer.bind(this);
        this.onExtraButtonMid = this.onExtraButtonMid.bind(this);
      }
      onRunTimer(){
        const {msg} = this.state;
        if(msg && msg.timerFn){
          let timer = setInterval(() => {
            const {messageKey, messageParams, isKillTimer} = msg.timerFn();
            if(isKillTimer){
              clearInterval(timer);
            }
            let message = this.state.msg;
            message['id'] = messageKey;
            message['messageParams'] = messageParams;
            this.setState({
              msg: message
            })
          }, 1000);
          this.setState({
            timer
          })
        }
      }
      componentDidMount(){
        // udpate message 
        this.onRunTimer();
      }
      onOk() {
        const { timer, msg } = this.state;
        if (timer) {
          clearInterval(timer);
        }
        const hasCheckbox = !!msg.checkbox?msg.checkbox:null;
        this.props.onOk(!!hasCheckbox && {checked:this.state.checked});
      }
      onExtraButtonMid(){
        if(this.state.timer){
          clearInterval(this.state.timer);
        }
        this.props.onExtraButtonMid();
      }
      onCancel(date){
        if(this.state.timer){
          clearInterval(this.state.timer);
        }
        if(this.props.onClose){
          this.props.onClose({checked:this.state.checked,key:date});
          return;
        }
        if(this.props.onCancel){
          this.props.onCancel({checked:this.state.checked,key:date});
          return;
        }
        const {msg} = this.props;
        if(msg && msg.closable !== void 0){
          this.props.onOk();
        }
      }
      onClose = () => {
        if (this.props.onCustomClose) {
          this.props.onCustomClose();

          return
        }
      }
      onCheckBox(e){
        
        this.setState({
          checked: e.target.checked
        })
      }
      onClickMsg = (ev)=>{
        const { msg } = this.state;
        const node = ev.target;
        let className = node.className;
        let pos = className.indexOf('jump-url');
        if(pos !== -1){
          msg.messageParams.url && (window.location.href = msg.messageParams.url);
          return;
        }
      }
      render() {
        const {visible/* , msg */} = this.props;
        const {checked, msg} = this.state;
        let isShowClose = this.props.onClose?true:false;
        let titleKey = !!msg.title?msg.title:'PhantomPDF.Online.TitleWithOnline'
        let cancelKey = !!msg.cancel?msg.cancel:'Cancel';
        let okKey = !!msg.ok?msg.ok:'Ok';
        let customClose = !!msg.customClose
        let closable = isShowClose;
        let checkbox = !!msg.checkbox?msg.checkbox:null;
        let isI18n = msg.isI18n === false ? false : true;
        let extraButtonMid = msg.extraButtonMid;
        if(msg.closable !== void 0){
          closable = msg.closable;
        }
        let isShowCancel;
        if (typeof(msg.noCancel) == 'undefined') {
          isShowCancel = isShowClose;
        } else {
          isShowCancel = !msg.noCancel;
        }
        let noConfirm = msg.noConfirm;
        let zIndex = msg.zIndex === undefined ? 1050 : msg.zIndex; // 1050为online弹窗默认层级
        const buttons = [
          isShowCancel?(<Button key="back" onClick={()=>this.onCancel(msg.cancel||'Cancel')}>{isI18n ? intl.get(cancelKey) : cancelKey}</Button>):void 0,
          !!extraButtonMid?(<Button key="extraButtonMid" type="primary" onClick={this.onExtraButtonMid}>{intl.get(extraButtonMid)}</Button>):void 0,
          noConfirm?void 0:(<Button key="submit" type="primary" onClick={this.onOk}>{isI18n ? intl.get(okKey) : okKey}</Button>)
        ].filter(Boolean);
        
        return (
          <React.Fragment>
            {
              !isMobile && <Modal
                visible={visible}
                className={`common-dialog ant-alert-modal ${msg.containerClass}`}
                title={isI18n ? intl.get(titleKey) : titleKey}
                onOk={this.onOk}
                onCancel={!customClose ? this.onCancel : this.onClose}
                closable={closable}
                footer={buttons}
                zIndex={zIndex}>
                <div className={`msg-dlg-content-wrapper ` + (msg.iconType === 'prompt' ? 'prompt' : '')} onClick={this.onClickMsg}>
                  <div className={`msg-wrapper ` + (msg.iconType === 'prompt' ? 'prompt-wrapper' : '')}>
                    {msg.iconType === 'warning' && <i className="msg-icon warning"/>}
                    {msg.iconType === 'alert' && <i className="msg-icon alert"/>}
                    {msg.iconType === 'error' && <i className="msg-icon error"/>}
                    {msg.iconType === 'inquiry' && <i className="msg-icon inquiry"/>}
                    {msg.iconType === 'prompt' && <i className="msg-icon prompt"/>}
                    <div className="content-body">
                      {msg.contentComponent && msg.contentComponent}
                      {isI18n ? (msg.id && intl.getHTML(msg.id, msg.messageParams)) : msg.id} 
                      {msg.subLink?<div>{intl.get('account.visitSubscription')}（<a onClick={()=>store.userStore.setSubscribeVisible(true)}>https://www.foxit.com/shopping/</a>）</div>:''}
                    </div>
                  </div>
                  {!!checkbox && 
                    <div className='mt_22'>
                      <Checkbox className='checkbox-todo' checked={checked} onChange={this.onCheckBox}>{isI18n ? intl.get(checkbox.title) : checkbox.title}</Checkbox>
                    </div>
                  }
                </div>
              </Modal>
            }
            {
            isMobile && 
              <div className="fwMobileDialog">
                <div className="fwMobileDialogBox"  onClick={(e) =>{e.stopPropagation()}}>
                  <div className="fwMobileDialogMain">
                    <h3 className="fwMobileDialogTitle">提示</h3>
                    {/* <img src={require("@/assets/fw_cloud_editor_mobile/img_warnning.png")}></img> */}
                    <p>{isI18n ? intl.getHTML(msg.id, msg.messageParams) : msg.id}</p>
                    {/* <p>
                      文件打开失败: 不是一个PDF文件或该文件已损坏。请确认文件路径是否正确。
                    </p> */}
                  </div>
                  <div className="fwMobileDialogBoxFooter">
                    <span key="back" className="fwMobileDialogFooterCancel" onClick={this.onCancel}>取消</span>
                    <span key="submit" className="fwMobileDialogFooterOK" onClick={this.onOk}>确定</span>
                  </div>
                </div>
              </div>
            }
          </React.Fragment>
          
        );
      }
}
